import deviceType from "@deepberry/common/data/device_type.json";
export default deviceType.devices;
